import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  Header
} from "./../Components/Fee&Expenses/styles.js";
import BalanceDetailsTable from './../Components/BalanceDetailsTable/BalanceDetailsTable.js';
import BalanceDetailsTablePrint from './../Components/BalanceDetailsTable/BalanceDetailsTablePrint.js';
import { ExportPrint, IconWrap, ExtraBalWrap, IconPadding, DataExportPrint, Print } from "./TabsComponent/styles";
import exportImg from './../../../assets/icons/export.svg';
import formatter from './../../../utils/formatter';
import { AccountTableContainer } from './BalanceDetailsTable/styles.js';
import { milliToDate, initiateTracking } from './../../../utils/commonUtil';
import { getTitleYearsText } from './../Pages/txnUitls'
import { exportExcelTableData } from "../../../services/apiServices";
import { getPrimaryAccount } from "./../../../utils/sessionUtil";
import PrintComponents from "react-print-components";
import printIcon from "./../../../assets/icons/print.svg";
import { StyleLessButton } from "../../../CommonComponents/commonStyles";

export const ExportContent = props => {
  return (
    <ExtraBalWrap>
      <IconWrap marginRight="3px">
        <img src={exportImg} alt="Export" /> &nbsp;
        <ExportPrint id="anrPrintBalance" onClick={() => exportAccountBalanceHistory(props)}>EXPORT</ExportPrint>
      </IconWrap>
    </ExtraBalWrap>
  )
}

const exportAccountBalanceHistory = (props) => {
  initiateTracking('export', props.pageTitle, 'Account balance history', 'Export')
  let filename = 'Account Balance History';
  let url = `/donor-portal/api/account/${getPrimaryAccount().userId}/exportBalanceHistory`;
  return exportExcelTableData(url, props.data, filename);
}

export const BalanceDetails = (props) => {
  const yearsText = getTitleYearsText(props.selectedVal);
  return (
    <div data-test="transaction-balance-details">
      <AccountTableContainer>
        <div className='account-balance-print'>
        <ExportContent data={props.filterData} />
        <PrintComponents
                        className="i_print"
                        trigger={
                          <Print>
                          <StyleLessButton>
                            <IconPadding className="ml2">
                              <img src={printIcon} alt="print"/>
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                          </Print>
                        } >
                          <BalanceDetailsTablePrint />   
                        </PrintComponents>
                        </div>
        {
          (yearsText !== "")
            ?
            <Header marginBottom="0">Showing balance details from {yearsText}</Header>
            :
            <Header marginBottom="0">Showing balance details from {props.filterMinDate} to {props.filterMaxDate}</Header>
        }
        <BalanceDetailsTable />
      </AccountTableContainer>
    </div>
  )
}


BalanceDetails.propTypes = {
  selectedVal: PropTypes.arrayOf(PropTypes.string),
  balanceDetails: PropTypes.object,
  filterMaxDate: PropTypes.string,
  filterMinDate: PropTypes.string
}

const mapStateToProps = state => ({
  balanceDetails: state.getIn(["transactionSummary", "balanceDetails", "data"]),
  filterData: state.getIn([
    "transactionSummary",
    "filterData",
    "data",
    "sortedBalanceDetails"
  ])
});
export default connect(mapStateToProps)(BalanceDetails);